import { css } from '@emotion/css';

export const buttonIcon = css`
  width: auto !important;
  height: auto !important;
`;

export const buttonInput = css`
  display: none;
`;

export const uploadButton = css`
  padding: 13px 12px;
  border: 1px dashed #bfbfbf;
  box-sizing: border-box;
  border-radius: 8px;
`;
